import { useEffect, useState } from 'react';
import useScript, { ScriptStatus } from '../../../helpers/useScript.js';
import { useAppSelector } from '../../hooks.js';
import { appleClientIdSelector } from './loginWithAppleSlice.js';
import { SCRIPT_URLS } from '../../../configs/constants/urls.js';
const commonAppleLoginConfigs = {
    clientId: undefined,
    scope: 'email',
    redirectURI: undefined,
    usePopup: true,
};
const scriptFlag = '__appleLoginScript__';
export const useAppleLogin = () => {
    const script = useScript(SCRIPT_URLS.APPLE_AUTH);
    const clientId = useAppSelector(appleClientIdSelector);
    const [loaded, setLoaded] = useState(false);
    useEffect(() => {
        if (typeof window !== 'undefined' &&
            !window?.[scriptFlag] &&
            window.AppleID &&
            script === ScriptStatus.READY) {
            window.AppleID.auth.init({
                ...commonAppleLoginConfigs,
                clientId,
                redirectURI: window.location.origin,
            });
            window[scriptFlag] = true;
            setLoaded(true);
        }
    }, [script, clientId]);
    return { initialized: window[scriptFlag] || loaded };
};
//# sourceMappingURL=useAppleLogin.js.map